import { gqlClient } from 'graphql/gqlClient';
import {
  CHECK_SLACK_CHANNEL_EXISTS,
  COMPANY_SLACK_CHANNELS_FROM_DB
} from 'graphql/queries/company-slack/company-channels';
import {
  COMPANY_SLACK_WORKSPACES_FROM_DB,
  SlackWorkspace
} from 'graphql/queries/company-slack/company-workspaces';

export interface ListSlackChannelsParams {
  search?: string;
  page: number;
  perPage: number;
  slackTeamId?: string;
}

interface SlackChannel {
  channelId: string;
  channelName: string;
  teamId?: string;
  slackTeamName?: string;
}

interface GetSlackChannelsResponse {
  channels: SlackChannel[];
  totalCount: number;
  otherWorkspaceChannels?: SlackChannel[];
  otherWorkspaceTotalCount?: number;
}

interface GetCompanySlackWorkspacesResponse {
  companySlackWorkspacesFromDb: {
    workspaces: SlackWorkspace[];
    isEnterpriseInstall: boolean;
  };
}

const getSlackChannels = async (
  params: ListSlackChannelsParams
): Promise<GetSlackChannelsResponse> => {
  const result = await gqlClient.request<{
    companySlackChannelsFromDb: {
      totalCount: number;
      channels: Array<{ channelId: string; channelName: string }>;
      otherWorkspaceChannels?: Array<{
        channelId: string;
        channelName: string;
        teamId?: string;
        slackTeamName?: string;
      }>;
      otherWorkspaceTotalCount?: number;
    };
  }>(COMPANY_SLACK_CHANNELS_FROM_DB, params);

  return {
    channels: result.companySlackChannelsFromDb.channels,
    totalCount: result.companySlackChannelsFromDb.totalCount,
    otherWorkspaceChannels: result.companySlackChannelsFromDb.otherWorkspaceChannels,
    otherWorkspaceTotalCount: result.companySlackChannelsFromDb.otherWorkspaceTotalCount
  };
};

const checkSlackChannelExists = async (channelName: string): Promise<boolean> => {
  const result = await gqlClient.request<{ checkSlackChannelExists: boolean }>(
    CHECK_SLACK_CHANNEL_EXISTS,
    { channelName }
  );
  return result.checkSlackChannelExists;
};

const getCompanySlackWorkspaces = async (): Promise<{
  workspaces: SlackWorkspace[];
  isEnterpriseInstall: boolean;
}> => {
  const result = await gqlClient.request<GetCompanySlackWorkspacesResponse>(
    COMPANY_SLACK_WORKSPACES_FROM_DB
  );

  return result.companySlackWorkspacesFromDb;
};

export const companySlackApi = {
  listChannels: getSlackChannels,
  listWorkspaces: getCompanySlackWorkspaces,
  channelNameExists: checkSlackChannelExists
};
